import { http } from "@/core/api/";
import academicYearService from "../common/academicyear.api";

const apiUrl = "api/studentanswerrp";
const reportBaseURL = "api/report";

export const getRemedyFilters = () => http.get(`${apiUrl}/initfilters`);

export const getReportRequest = requestNumber =>
  http.get("/api/studentevaluation/requestreportdownload", {
    params: {
      requestNumber
    }
  });

export const getRequestServicesById = requestId =>
  http.get(`${apiUrl}/requestservicesbyid`, {
    params: {
      requestId
    }
  });

export const getRequestServices = (filters, pageIndex, pageSize) =>
  http.get(`${apiUrl}/requestservices`, {
    params: {
      ...filters,
      pageIndex,
      pageSize
    }
  });

export const getRpStatusHistory = (requestServiceId, pageIndex, pageSize) =>
  http.get(`${apiUrl}/servicestatushistory/${requestServiceId}`, {
    params: {
      pageIndex,
      pageSize
    }
  });

export const getRpRequestDocuments = id =>
  http.get(`${apiUrl}/requestdocuments/${id}`);

export const getAppointment = filters =>
  http.get(`${apiUrl}/studentappointment`, {
    params: {
      ...filters
    }
  });

export const getDeterminationRequestService = requestServiceId =>
  http.get(`${apiUrl}/determinationrequestserviceid`, {
    params: {
      requestServiceId
    }
  });

export const getDeterminationReasons = (serviceStatusId, serviceTypeId) =>
  http.get(`${apiUrl}/determinationreasons`, {
    params: {
      serviceStatusId,
      serviceTypeId
    }
  });

export const getReasonCategories = reasonId =>
  http.get(`${apiUrl}/reasonCategories`, {
    params: {
      reasonId
    }
  });

export const saveDetermination = params =>
  http.post(`${apiUrl}/savedetermination`, params, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });

export const returnToPreviousStatus = payload =>
  http.post(`${apiUrl}/returntopreviousstatus`, payload);

export const getRpPreviousStatus = requestServiceId =>
  http.get(`${apiUrl}/statustoreturn`, {
    params: {
      requestServiceId
    }
  });

export const getCheckStudentAdmission = (
  academicYearId,
  studentSieId,
  disciplineTypeId
) =>
  http.get(
    `${apiUrl}/checkstudentadmission/${academicYearId}/${studentSieId}/${disciplineTypeId}`
  );

export const getDeterminationLetterReport = filters =>
  http.get(`${reportBaseURL}/determinationletter`, {
    params: {
      ...filters
    }
  });

export const getRequestReport = requestServiceId =>
  http.get(`${reportBaseURL}/request`, {
    params: {
      requestServiceId
    }
  });

export const getRequestServicesReport = filters =>
  http.get(`${reportBaseURL}/requestservices`, {
    params: {
      ...filters
    }
  });

export const getDisciplineTypesForSaee = serviceTypeId =>
  http.get(`${apiUrl}/disciplineTypesForSaee/${serviceTypeId}`);

export default {
  //Filters
  async getAcademicYearsAnswerRequest() {
    return await academicYearService.getAcademicYearsAnswerRequest();
  },
  async getRequestServiceStatus() {
    const { status, data: response } = await http.get(
      `${apiUrl}/requestservicestatus`
    );
    return status !== 200 ? {} : response;
  },
  async getRequestServiceType() {
    const { status, data: response } = await http.get(
      `${apiUrl}/requestservicetype`
    );
    return status !== 200 ? {} : response;
  },

  //Search Answer
  async getAnswerRequestRpHistory(filter) {
    let response = await http.get(`${apiUrl}/answerrequestrphistory`, {
      params: filter
    });

    if (response.data) {
      return response.data;
    }
    return [];
  },
  async getReasonsBy(id) {
    let response = await http.get(`${apiUrl}/${id}/determinationreasons`);

    if (response.data) {
      return response.data;
    }
    return [];
  },
  async saveDetermination(id, body) {
    let response = await http.post(`${apiUrl}/${id}/saveDetermination`, body);

    if (response.data) {
      return response.data;
    }
    return [];
  }
};
